export const trackFaqAccordionOpen = (accordionLabel: string): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'faq_open', {
      event_category: 'Faq open',
      faq_title: accordionLabel,
      value: 1,
    });
  }
};

export const trackAccordionOpen = (service: string, title: string): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'accordion_open', {
      event_category: 'Accordion open',
      accordion_title: service + '-' + title,
      value: 1,
    });
  }
};

export const trackAccordionTimeSpent = (service: string, title: string, duration: number): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'accordion_time_spent', {
      event_category: 'Accordion open',
      accordion_title: service + '-' + title,
      event_label: service + '-' + title,
      value: duration,
    });
  }
};
